import * as React from "react";
import { MoneyDisplayHelper } from "../../../../../../../../../react-core/Helpers/MoneyDisplayHelper";
import { StringHelper } from "../../../../../../../../../react-core/Helpers/StringHelper";
import { CurrencyCode } from "../../../../../../../../../Wrap/Constants/Enums/Domain/CurrencyCode";
import { MoneyInTransactionSummary } from "../../../../../../../../../Wrap/Models/Domains/Transactions/Summary/MoneyInTransactionSummary";
import { Table } from "../../../../../../../../Shared/Table/Table";

interface IMoneyInTableProps {
    data: Array<MoneyInTransactionSummary>;
}

export const PaymentsInTable = (props: IMoneyInTableProps) => {
    const stringHelper = new StringHelper();
    return (
        <div>
            <Table
                data={props.data}
                rowCssWrapper={"product-heading"}
                col={[
                    {
                        title: "Product",
                        key: "ClAccountId",
                        render: (data, row, index) => {
                            return (
                                <>
                                    <span
                                        aria-hidden="true"
                                        className={"product-legend " + stringHelper.getDonutClass(row.ProductType)}
                                    ></span>
                                    <span className={stringHelper.getDonutClass(row.ProductType) + "-text"}>
                                        {row.ProductDisplayName}
                                    </span>
                                    <span className="account">{data}</span>
                                </>
                            );
                        },
                    },
                    {
                        title: "Regular payment",
                        key: "RegularPaymentAmount",
                        render: (data, row, index) => {
                            return MoneyDisplayHelper.getMoneyFormatWithEmpty(
                                { Amount: data, Currency: CurrencyCode.GBP },
                                "-",
                                true
                            );
                        },
                        thCssWrapper: "cell-right",
                        tdCssWrapper: "cell-right",
                    },
                    {
                        title: "Single payment",
                        key: "SinglePaymentAmount",
                        thCssWrapper: "cell-right",
                        tdCssWrapper: "cell-right",
                        render: (data, row, index) => {
                            return MoneyDisplayHelper.getMoneyFormatWithEmpty(
                                { Amount: data, Currency: CurrencyCode.GBP },
                                "-",
                                true
                            );
                        },
                    },
                    {
                        title: "Transfer",
                        key: "TransferAmount",
                        thCssWrapper: "cell-right",
                        tdCssWrapper: "cell-right",
                        render: (data, row, index) => {
                            return MoneyDisplayHelper.getMoneyFormatWithEmpty(
                                { Amount: data, Currency: CurrencyCode.GBP },
                                "-",
                                true
                            );
                        },
                    },
                    {
                        title: "Interest distributions",
                        key: "InterestDistributionsAmount",
                        thCssWrapper: "cell-right",
                        tdCssWrapper: "cell-right",
                        render: (data, row, index) => {
                            return MoneyDisplayHelper.getMoneyFormatWithEmpty(
                                { Amount: data, Currency: CurrencyCode.GBP },
                                "-",
                                true
                            );
                        },
                    },
                    {
                        title: "Income distributions",
                        key: "IncomeDistributionsAmount",
                        thCssWrapper: "cell-right",
                        tdCssWrapper: "cell-right",
                        render: (data, row, index) => {
                            return MoneyDisplayHelper.getMoneyFormatWithEmpty(
                                { Amount: data, Currency: CurrencyCode.GBP },
                                "-",
                                true
                            );
                        },
                    },
                    {
                        title: "Total",
                        key: "SurrenderAmount",
                        thCssWrapper: "cell-right",
                        tdCssWrapper: "cell-right",
                        render: (data, row, index) => {
                            return MoneyDisplayHelper.getMoneyFormatWithEmpty(
                                {
                                    Amount:
                                        row.RegularPaymentAmount +
                                        row.SinglePaymentAmount +
                                        row.TransferAmount +
                                        row.InterestDistributionsAmount +
                                        row.IncomeDistributionsAmount,
                                    Currency: CurrencyCode.GBP,
                                },
                                "-",
                                true
                            );
                        },
                    },
                ]}
                TotalBody={[
                    { data: "Portfolio total" },
                    {
                        data: MoneyDisplayHelper.getMoneyFormatWithEmpty(
                            {
                                Amount: (props.data || []).reduce((total, ele) => {
                                    return total + ele.RegularPaymentAmount;
                                }, 0),
                                Currency: CurrencyCode.GBP,
                            },
                            "-",
                            true
                        ),
                    },
                    {
                        data: MoneyDisplayHelper.getMoneyFormatWithEmpty(
                            {
                                Amount: (props.data || []).reduce((total, ele) => {
                                    return total + ele.SinglePaymentAmount;
                                }, 0),
                                Currency: CurrencyCode.GBP,
                            },
                            "-",
                            true
                        ),
                        tfTdCssWrapper: "cell-right",
                    },
                    {
                        data: MoneyDisplayHelper.getMoneyFormatWithEmpty(
                            {
                                Amount: (props.data || []).reduce((total, ele) => {
                                    return total + ele.TransferAmount;
                                }, 0),
                                Currency: CurrencyCode.GBP,
                            },
                            "-",
                            true
                        ),
                        tfTdCssWrapper: "cell-right",
                    },
                    {
                        data: MoneyDisplayHelper.getMoneyFormatWithEmpty(
                            {
                                Amount: (props.data || []).reduce((total, ele) => {
                                    return total + ele.InterestDistributionsAmount;
                                }, 0),
                                Currency: CurrencyCode.GBP,
                            },
                            "-",
                            true
                        ),
                        tfTdCssWrapper: "cell-right",
                    },
                    {
                        data: MoneyDisplayHelper.getMoneyFormatWithEmpty(
                            {
                                Amount: (props.data || []).reduce((total, ele) => {
                                    return total + ele.IncomeDistributionsAmount;
                                }, 0),
                                Currency: CurrencyCode.GBP,
                            },
                            "-",
                            true
                        ),
                        tfTdCssWrapper: "cell-right",
                    },
                    {
                        data: MoneyDisplayHelper.getMoneyFormatWithEmpty(
                            {
                                Amount: (props.data || []).reduce((total, ele) => {
                                    return (
                                        total +
                                        ele.RegularPaymentAmount +
                                        ele.SinglePaymentAmount +
                                        ele.TransferAmount +
                                        ele.InterestDistributionsAmount +
                                        ele.IncomeDistributionsAmount
                                    );
                                }, 0),
                                Currency: CurrencyCode.GBP,
                            },
                            "-",
                            true
                        ),
                        tfTdCssWrapper: "cell-right",
                    },
                ]}
            ></Table>
        </div>
    );
};
